<template>
  <el-dialog
    :title="title"
    class="dialog"
    :visible="visible"
    @update:visible="visibleHandle">
    <jm-alertSubscribe
      :title="title"
      :type="type"
      :visible="visible"
      :data-set="dataSet"
      :operate-visit="operateVisit"
      :increase-type="increaseType"
      @update:visible="visibleHandle"
      @finished="finished"
      v-bind="$attrs"
      :crm_level="crm_level"
      :crm_sayer="crm_sayer"
      ref="closeReset"/>
  </el-dialog>
</template>
<script>
const alertSubscribe = () => import('./alertSubscribe.vue');

export default {
  props: {
    title: '',
    type: '',
    increaseType: '',
    visible: {
      type: Boolean,
      default: false,
    },
    dataSet: {
      type: Object,
      default () {
        return {};
      }
    },
    operateVisit: {
      type: String,
      default: '',
    },
    crm_level: {
      type: [Number, String],
    },
    crm_sayer: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    visibleHandle(v) {
      this.$emit('update:visible', v);
    },
    finished(params) {
      this.$emit('finished', params);
    }
  },
  mounted() {
    // console.log(this.crm_sayer);
  },
  components: {
    'jm-alertSubscribe': alertSubscribe,
  },
  watch: {
    /*
    * 监听是否关闭 dialog 重置子组件验证信息
    * */
    visible (val) {
      if (val === false) {
        let formName = this.type === 'visit' ? 'visitForm' : 'appointmentForm';
        this.$refs.closeReset.resetForm(formName);
      }
    }
  }
};
</script>
